// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"b40570ab","139":"5803ac31","155":"b0839270","366":"cd5d642d","465":"617e3857","579":"40c55ea3","829":"617e3857","887":"617e3857","905":"6c055e76"}[chunkId] + ".chunk.css";
};